import * as React from 'react';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { InjectedRouter } from 'react-router';
import { IStore } from 'redux/IStore';
import * as c from 'models/constants';
import { Button, ErrorSummary, LoadingOverlayWrapper } from 'components';
import { PortalPageSection, ButtonsSection, PageTitle } from 'components/PortalStructure';
import { preventRouterLeave } from 'helpers/hooks';
import { getCountryDomainValues } from 'modules/domainvalues';
import { IDomainValuesAction } from 'models/domainvalues/domainvalues';
import { IShopProfile } from 'models/shop/shopprofile';
import { IManageShop, IManageShopAction } from 'models/shop/manageshop';
import { getShop, putShop } from 'modules/shop/manageshop';
import { ManageShopWrapper } from 'containers';
import { IDomainValue } from 'models/common';
import { ShopAddressForm } from 'containers/Common/AddressForms/ShopAddressForm';
interface IProps {
	manageShop?: IManageShop;
	currentFormValues: IShopProfile;
	initialValues: IShopProfile;
	params?: IParams;
	countryDomainValues: IDomainValue[];
	location: any;
	router: InjectedRouter;
	route: any;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	/* functions props */
	t?: (key: string) => string;
	getCountryDomainValues?: () => IDomainValuesAction;
	getShop: (id: string, isShipping: boolean) => IManageShopAction;
	putShop: (shop: IShopProfile) => IManageShopAction;
}

interface IParams {
	id?: string;
}

@preventRouterLeave()
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManageShopAddressForm extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
	}

	public componentDidMount() {
		this.props.getShop(this.props.params.id, false);
		this.props.getCountryDomainValues();
	}

	public onSubmit(form: IShopProfile) {
		this.props.putShop(form);
	}

	private mapErrorKeyToMessage(key: string, t: (key: string) => string) {
		switch (key) {
			case 'name':
			case 'shippingName':
				return t('Shop_ManageShop_ShippingAddress_Label_Name');
			case 'address':
			case 'shippingAddress':
				return t('Shop_ManageShop_ShippingAddress_Label_Address');
			case 'city':
			case 'shippingCity':
				return t('Shop_ManageShop_ShippingAddress_Label_City');
			case 'postalCode':
			case 'shippingPostalCode':
				return t('Shop_ManageShop_ShippingAddress_Label_PostalCode');
			case 'fromCountryKey':
			case 'shippingFromCountryKey':
				return t('Shop_ManageShop_ShippingAddress_Label_CountryCode');
			case 'province':
			case 'shippingProvince':
				return t('Shop_ManageShop_ShippingAddress_Label_Province');
			case 'email':
			case 'shippingEmail':
				return t('Shop_ManageShop_ShippingAddress_Label_Email');
			case 'phone':
			case 'shippingPhone':
				return t('Shop_ManageShop_ShippingAddress_Label_Phone');
			case 'notes':
			case 'shippingNotes':
				return t('Shop_ManageShop_ShippingAddress_Label_Notes');
			default:
				return key;
		}
	}

	public render() {
		const { handleSubmit, t, formErrors, submitFailed, submitting, pristine, location, countryDomainValues } =
			this.props;

		const errorSummaryProps = {
			formErrors,
			submitFailed,
			error: this.props.manageShop ? this.props.manageShop.error : false,
			message: this.props.manageShop ? this.props.manageShop.message : null,
			location,
			mapErrorKeyToMessage: this.mapErrorKeyToMessage,
		};

		return (
			<ManageShopWrapper id={this.props.params.id}>
				<div className="shopGeneralFormWrapper">
					<PageTitle title={t('Shop_ManageShop_General_Label_General')} />
					<LoadingOverlayWrapper
						active={this.props.manageShop.isFetching}
						spinner={true}
						text={t('BSPortal_Common_Loading')}
						background="rgba(0, 0, 0, 0.1)"
					>
						<form onSubmit={handleSubmit(this.onSubmit)}>
							<div className="profileError">
								<ErrorSummary {...errorSummaryProps} />
							</div>
							<Field name="id" component="input" type="hidden" />
							<PortalPageSection title={t('Shop_ManageShop_ShippingOption_Label_Address')}>
								<ShopAddressForm keyPrefix="" t={t} countryDomainValues={countryDomainValues} />
							</PortalPageSection>
							<ButtonsSection>
								<div className="row">
									<div className="col-sm-6" />
									<div className="col-sm-6">
										<div className="floatRight">
											<Button type="submit" disabled={pristine || submitting}>
												{t('BSPortal_Common_SaveChanges')}
											</Button>
											<div className="clear" />
										</div>
										<div className="clear" />
									</div>
								</div>
							</ButtonsSection>
						</form>
					</LoadingOverlayWrapper>
				</div>
			</ManageShopWrapper>
		);
	}
}

let ManageShopAddress = reduxForm({
	form: c.FORM_NAME_MANAGE_SHOP,
	enableReinitialize: true,
})(ManageShopAddressForm);

ManageShopAddress = connect(
	(state: IStore) => {
		let currentFormValues: IShopProfile = null;
		if (state.form[c.FORM_NAME_MANAGE_SHOP] && state.form[c.FORM_NAME_MANAGE_SHOP].values) {
			currentFormValues = state.form[c.FORM_NAME_MANAGE_SHOP].values;
		} else {
			currentFormValues = state.manageShop.shop;
		}

		return {
			initialValues: state.manageShop.shop,
			manageShop: state.manageShop,
			currentFormValues,
			formErrors: getFormSyncErrors(c.FORM_NAME_MANAGE_SHOP)(state),
			countryDomainValues: state.domainValues.countries,
		};
	},
	(dispatch) => ({
		getCountryDomainValues: () => dispatch(getCountryDomainValues()),
		getShop: (id: string, isShipping: boolean) => dispatch(getShop(id, isShipping)),
		putShop: (form: IShopProfile) => dispatch(putShop(form)),
	}),
)(ManageShopAddress);

export { ManageShopAddress };
